import React from 'react';
import cn from 'clsx';
import { CheckboxProps } from 'common/types/types';

import styles from './styles';

const Checkbox = ({
  name,
  value,
  checked = false,
  theme = 'default',
  label,
  placeholder,
  invalid,
  onChange,
  stylesConfig,
  disabled = false,
}: CheckboxProps) => {
  const inputClassName = cn(styles[theme].input, invalid && styles[theme].error);

  return (
    <div className={styles[theme].container}>
      <input
        id={name}
        name={name}
        disabled={disabled}
        type='checkbox'
        placeholder={placeholder}
        className={inputClassName}
        onChange={onChange}
        value={value}
        checked={checked}
        style={stylesConfig?.inputStyle}
      />
      {label && (
        <label htmlFor={name} className={styles[theme].label} style={stylesConfig?.labelStyle}>
          {label}
        </label>
      )}
    </div>
  );
};

export { Checkbox };
